import { useIntl } from '@capsicum/common';

export const useNCWTestBeforeSendAlert = () => {
	const { $t } = useIntl();
	const infoTitle = $t('ncWallet.send.enterAmount.infoTitle');
	const infoSubtitle = $t('ncWallet.send.enterAmount.infoSubtitle');

	return {
		intlText: {
			infoSubtitle,
			infoTitle
		}
	};
};
